import { Form, Formik, FormikValues } from "formik";
import SsnEinModalFields from "./SsnEinModalFields";
import * as Yup from "yup";
import { useAppDispatch } from "src/store/store";
import { setIsSubmitted, useUserSlice } from "src/store/features/user.slice";
import { UpdateSsnEinDto } from "src/store/features/api/generated";
import api from "src/store/features/api";
import { LinearProgress } from "@mui/material";

export default function UsaSsnEinCollection() {
  const [submitForm, { isLoading }] = api.useUpdateSsnEinMutation();
  const initialValues = {
    ssn: "",
    ein: "",
  };

  const {
    salesforceDetails: { ssnRequired, einRequired },
  } = useUserSlice();

  const dispatch = useAppDispatch();

  const validationSchema = () => {
    return Yup.object().shape({
      ssn: Yup.string()
        .matches(/^\d{3}-\d{2}-\d{4}$/, "SSN must contain 9 digits")
        .test("not-123-45-6789", "SSN cannot be 123-45-6789", (value) => value !== "123-45-6789")
        .test(
          "not-same-digit-ssn",
          "SSN cannot consist of the same digit repeated 9 times",
          (value?: string) => !/^(\d)\1{2}-\1{2}-\1{4}$/.test(value ?? ""),
        )
        .when([], {
          is: () => ssnRequired,
          then: Yup.string().required("SSN is required"),
        }),
      ein: Yup.string()
        .matches(/^\d{2}-\d{7}$/, "EIN must contain 9 digits")
        .test("not-12-3456789", "EIN cannot be 12-3456789", (value) => value !== "12-3456789")
        .test(
          "not-same-digit-ein",
          "EIN cannot consist of the same digit repeated 9 times",
          (value?: string) => !/^(\d)\1{1}-\1{7}$/.test(value ?? ""),
        )
        .when([], {
          is: () => einRequired,
          then: Yup.string().required("EIN is required"),
        }),
    });
  };

  // Handling form submission

  const handleSubmit = async (
    values: FormikValues,
    setFieldError: (field: string, message: string | undefined) => void,
  ) => {
    const { ssn, ein } = values;

    // remove "-" from ssn and ein

    const ssnToSubmit = ssn.replace(/-/g, "");
    const einToSubmit = ein.replace(/-/g, "");

    const updateSsnEinDto: UpdateSsnEinDto = {
      ssn: ssnToSubmit,
      ein: einToSubmit,
    };

    await submitForm({ updateSsnEinDto })
      .then(() => {
        dispatch(setIsSubmitted(true));
      })
      // Alert the user in case of an error
      .catch((error) => {
        window.alert("Error submitting SSN/EIN");
        console.error(error);
      });
  };

  return (
    <div>
      {isLoading && (
        <>
          <LinearProgress />
        </>
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values, { setFieldError }) => handleSubmit(values, setFieldError)}>
        <Form>
          {/* SSN and EIN Fields*/}
          <SsnEinModalFields isLoading={isLoading} />
        </Form>
      </Formik>
    </div>
  );
}
